import { CheckInServiceID } from "./CheckIn";
import { ChecklistID } from "./Checklist";
import { DealerLocationID } from "./DealerLocation";
import { PIN_TYPES } from "./Pin";

export interface PinPendingChecklist {
  created_on: string;
  updated_on: string;
  dealer_location_id: DealerLocationID; // Location Identifier
  pin_type: PIN_TYPES; // Pin Type
  checklist_id: ChecklistID; // Checklist Identifier
  ordering: number; // When there are multiple checklists assigned to 1 intervention, this specifies the sequential ordering to display them in.
  vin_prefix: string; // This checklist is exclusive for the vin prefix mentioned, if its empty then checklist is applicable to all the vin prefixes.
  checklist_name?: string; // The name of the checklist that is pending
}

export interface CheckInServicePendingChecklist {
  created_on: string;
  updated_on: string;
  dealer_location_id: DealerLocationID; // Location Identifier
  checkin_service_id: CheckInServiceID; // Check In Service Identifier
  checklist_id: ChecklistID; // Checklist Identifier
  ordering: number; // When there are multiple checklists assigned to 1 intervention, this specifies the sequential ordering to display them in.
  checklist_name?: string; // The name of the checklist that is pending
}

export interface InterventionKeywordPendingChecklist {
  created_on: string;
  updated_on: string;
  dealer_location_id: DealerLocationID; // Location Identifier
  keyword: string; // Intervention Keyword
  checklist_id: ChecklistID; // Checklist Identifier
  ordering: number; // When there are multiple checklists assigned to 1 intervention, this specifies the sequential ordering to display them in.
  vin_prefix: string; // This checklist is exclusive for the vin prefix mentioned, if its empty then checklist is applicable to all the vin prefixes.
  checklist_name?: string; // The name of the checklist that is pending
}
